import { html, nothing, render } from "lit-html";
import { data } from "../../../shared/state/payload";
import { hasEscapioRate } from "@escapio/portal/state/escapio-deals-helpers";
import "@escapio/portal/components/hotel-list/hotel-element/EscapioDealBadge";
import "@escapio/portal/components/hotel-list/hotel-element/TopHotelBadge";
import { onChangeCurrency } from "@escapio/portal/state/travelData";
import "../ExclusiveBadge";

customElements.define(
	"esc-stage-badge",
	class extends HTMLElement {
		connectedCallback() {
			this.render();
			onChangeCurrency(() => this.render());
		}

		render() {
			render(
				hasEscapioRate(data.hotel)
					? html`<esc-escapio-deal-badge
							class="overlay-item"
						></esc-escapio-deal-badge>`
					: data.hotel.exclusive
						? html`<esc-exclusive-badge
								trigger-class="picture-badge exclusive-badge overlay-item is-translucent"
							></esc-exclusive-badge>`
						: data.hotel.is_top_hotel
							? html`<esc-top-hotel-badge
									class="overlay-item"
								></esc-top-hotel-badge>`
							: data.hotel.review_score
								? html`<div
										class="picture-badge hotel-satisfaction overlay-item is-translucent"
									>
										<span class="fa fa-thumbs-o-up fa--space-after"></span>
										<span>${data.hotel.review_score}</span>%
									</div>`
								: nothing,
				this,
				{
					host: this,
				},
			);
		}
	},
);
